import { render, staticRenderFns } from "./assign_internship_modal.vue?vue&type=template&id=0edcbb7d&scoped=true"
import script from "./assign_internship_modal.vue?vue&type=script&lang=js"
export * from "./assign_internship_modal.vue?vue&type=script&lang=js"
import style0 from "./assign_internship_modal.vue?vue&type=style&index=0&id=0edcbb7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edcbb7d",
  null
  
)

export default component.exports